<div class="Div-Container">
  <div fxLayout="row wrap" [hidden]="isEditing">
    <div fxFlex="100">
      <mat-sidenav-container>
        <mat-sidenav-content>
          <div class="card p-3 mt-3">
            <header class="sub-header p-1">
              <h5>Module List</h5>
              <div class="slidebtn-header-btn">
                <mat-slide-toggle (change)="GetInActiveRecords($event)" [checked]="ActiveNav" class="slide-toggle-btn">
                </mat-slide-toggle>
                <button mat-icon-button class="add-btn-container p-1" matSuffix (click)="addNavLink(undefined)">
                  <mat-icon>add</mat-icon> <span> Add Navigations</span>
                </button>
              </div>
            </header>
            <div class="mt-2">
              <!-- <header class="filter-header mb-3">
                <h5>Filter</h5>
              </header> -->
              <form [formGroup]="navlinkform">
                <div class="row mt-3">
                  <div class="col-md-4 col-lg-4 col-sm-12">
                    <mat-form-field class="w-100" appearance="outline">
                      <input matInput placeholder="Title" formControlName="title" />
                    </mat-form-field>
                  </div>
                  <div class="col-md-4 col-lg-4 col-sm-12">
                    <mat-form-field class="w-100" appearance="outline">
                      <mat-select placeholder="Parent Name" name="Parent" formControlName="parentName">
                        <mat-select-search autocomplete="off" placeholder="Parent Name"
                          [formControl]="ParentListCtrl">
                        </mat-select-search>
                        <mat-option [value]=""> None</mat-option>
                        <mat-option *ngFor="let mile of parentflt" [value]="mile.title">
                          <div class="dd-name">
                            <P>
                              {{mile.title}}
                            </P>
                            <p>{{mile.linkText | removeLeadingSlash }}</p>
                          </div>
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-md-4 col-lg-4 col-sm-12">
                    <div class="button-container">
                      <button (click)="GetSearchData()" class="btn btn-save btn-icon-text mb-2 mb-md-0 me-2">
                        <mat-icon>search</mat-icon>
                        Search
                      </button>
                      <button (click)="ClearSearch()" class="btn btn-cancel btn-icon-text mb-2 mb-md-0">
                        <mat-icon>clear</mat-icon>
                        Clear
                      </button>
                    </div>
                  </div>
                </div>

              </form>
            </div>
            <div class="table-responsive">
              <table mat-table [dataSource]="dataSource" matSort class="table">
                <ng-container matColumnDef="title">
                  <mat-header-cell *matHeaderCellDef   mat-sort-header> Title</mat-header-cell>
                  <mat-cell *matCellDef="let element">{{ element.title }}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="linkText">
                  <mat-header-cell *matHeaderCellDef   mat-sort-header> Link Text</mat-header-cell>
                  <mat-cell *matCellDef="let element">{{ element.linkText }}</mat-cell>
                </ng-container>
  
                  <ng-container matColumnDef="linkOrder">
                      <mat-header-cell *matHeaderCellDef   mat-sort-header>Link order</mat-header-cell>
                   <mat-cell *matCellDef="let element">{{ element.linkOrder }}</mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="parentName">
                      <mat-header-cell *matHeaderCellDef   mat-sort-header>Parent Name</mat-header-cell>
                   <mat-cell *matCellDef="let element">{{ element.parentName }}</mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="actions">
                      <mat-header-cell *matHeaderCellDef   mat-sort-header> Action</mat-header-cell>
                      <mat-cell *matCellDef="let element; let i =index">
                        <div class="table-actions-button-mat-cell">
                          <button *ngIf="!showEdits" mat-icon-button matTooltip="edit details" (click)="addNavLink(element)" class="action-btn edit-btn">
                            <mat-icon>edit</mat-icon>
                          </button>
                          <mat-slide-toggle *ngIf="!showDelete" [checked]="element.isDeleted" (change)="updateinactive(element,i,$event)" class="slide-toggle-btn">
                          </mat-slide-toggle>
                        </div>
                  </mat-cell>
                </ng-container>
  
                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
              </table>
            </div>
            <div *ngIf="dataSource.data.length == 0">
              <div class="no-results mt-5">
                <div class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="11" cy="11" r="8"/>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"/>
                  </svg>
                </div>
                <h1>No Results Found</h1>
              </div>
            </div>
            <mat-paginator #paginator [pageSizeOptions]="[5, 10,15,20,50,100]" [length]="resultlength" [pageSize]="10"
              showFirstLastButtons (page)="getDatas($event)">
            </mat-paginator>
          </div>


        </mat-sidenav-content>
      </mat-sidenav-container>
    </div>
  </div>
  <div *ngIf="Navlink">
    <app-navLink-dialog [item]="Navdata" (closeRequest)="closeForm($event)"></app-navLink-dialog>
  </div>
</div>